<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { BubbleQuestionIcon } from '@thehotelsnetwork/icons/vue/linear';

import { showProductTour } from '@/utils/productTour';

const props = defineProps<{
  flowId: string;
}>();

const { t } = useI18n();

function showProductTourFlow() {
  showProductTour(props.flowId);
}
</script>

<template>
  <button
    type="button"
    data-testid="trigger"
    @click="showProductTourFlow"
  >
    <div v-if="$slots.trigger">
      <slot name="trigger" />
    </div>
    <div
      v-else
      class="flex cursor-pointer justify-between text-sm font-bold text-base-700"
    >
      <BubbleQuestionIcon class="w-4 h-4 mr-2" />
      {{ t('Feeling lost? Take a tour') }}
    </div>
  </button>
</template>
